// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Profile-module--wrapper--3TO0v"};